export const listenKey = function(e: any) {
  const keyCode = window.navigator.platform.match('Mac') ? 'metaKey' : 'ctrlKey';
  const keyName = window.navigator.platform.match('Mac') ? 'Meta' : 'Control';
  if (e.type !== 'keydown' && e.type !== 'keyup') return;
  if (e[keyCode] || e.key === keyName) {
    window.$lx_ctrlKey = e[keyCode];
  }
};
